import React from 'react';
import styles from './Radio.module.scss';

const Radio = ({
  value,
  checkedValue,
  onChecked,
  label,
  description,
  ...otherProps
}) => {
  return (
    <label className={styles.radioWrapper}>
      <input
        type='radio'
        value={value}
        checked={value === checkedValue}
        onChange={onChecked}
        {...otherProps}
      />
      <span className={styles.checkmark}></span>
      <span className={styles.label}>{label}</span>
      {description && <span className={styles.description}>{description}</span>}
    </label>
  );
};
export default Radio;
